@if (caption()) {
    <span class="caption">{{ caption() }}</span>
}
<div class="control">
    <button (click)="previous.emit()" [attr.aria-label]="previousLabel()" [disabled]="previousDisabled()" type="button">
        <i class="fa-regular fa-chevron-left"></i>
    </button>
    <button (click)="labelClick.emit()" class="label" type="button">
        <span class="main">
            <ng-content select="[icon]"></ng-content>{{ label() }}
        </span>
        @if (sub()) {
            <span class="sub">{{ sub() }}</span>
        }
    </button>
    <button (click)="next.emit()" [attr.aria-label]="nextLabel()" [disabled]="nextDisabled()" type="button">
        <i class="fa-regular fa-chevron-right"></i>
    </button>
</div>
